module.exports = __webpack_public_path__ + "static/media/Ø3.3f406d79.png";